<template>
  <div class="walletParticulars" style="heigth:100%">
    <div class="balanceBox">
      <h5 class="tit"><i class="balanceIcon"></i>账户余额</h5>
      <div class="balanceMain">
        <h5>总余额</h5>
        <p>{{balance | number_format}}<span>译贝</span></p>
      </div>
      <el-popover placement="right" width="250" trigger="hover">
        <p style="line-height: 18px;margin: 10px;">1译贝=1人民币。单个账号每天超出10万字后，按5译贝/1000字消耗译贝。译贝暂不支持提现~</p>
        <i slot="reference" class="brule"></i>
      </el-popover>
    </div>
    <!-- <div class="brule">
      <h5 class="tit"><i class="bruleIcon"></i>译贝规则</h5>
      <div>一译贝=1人民币。单个账号每天超出10万字后，按5译贝/1000字消耗译贝。译贝暂不支持提现~</div>
    </div> -->
    <div class="strategy">
      <h5 class="tit"><i class="strategyIcon"></i>译贝攻略</h5>
      <ul>
        <li v-for="(item,index) in strategyList" :key="index">
          <p>{{item.remarkLef+ '+'}}{{item.amount | number_format(0)}}<span>{{item.remarkRig}}</span></p>
          <i v-if="item.finished" class="el-icon-circle-check"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: "walletParticulars",
  data() {
    return {
      balance: "",
      strategyList: []
    };
  },
  computed: {

  },
  created() {
    this.getBalance();
    this.getYbStrategy()
  },
  updated() {

  },
  filters: {
    number_format(number, decimals, dec_point, thousands_sep) {
      /*
       * 参数说明：
       * number：要格式化的数字
       * decimals：保留几位小数
       * dec_point：小数点符号
       * thousands_sep：千分位符号
       * */
      number = (number/100 + '').replace(/[^0-9+-Ee.]/g, '');
      var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
          var k = Math.pow(10, prec);
          return '' + Math.ceil(n * k) / k;
        };

      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
      var re = /(-?\d+)(\d{3})/;
      while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
      }

      if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
      }
      return s.join(dec);
    }
  },
  methods: {
    async getYbStrategy() {
      const { result, success } = await this.catReq1Service("/api/v1/user/get_user_account_rule", {}, "get");
      if (success) {
        this.strategyList = result;
        this.strategyList.forEach(item => {
          item.remarkLef = item.remark;
          item.remarkRig = "";
          let index = item.remark.indexOf(",");
          if (index != -1) {
            item.remarkLef = item.remark.slice(0, index)
            item.remarkRig = item.remark.slice(index + 1)
          }
          console.log(item.remarkLef, item.remarkRig, index);
        })
      }
    },
    async getBalance() {
      const { result, success } = await this.catReq1Service("/api/v1/user/get_user_account", {}, "get");
      if (success) {
        this.balance = result.userAccountBieTotal;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.walletParticulars {
  text-align: left;
  // margin-left: 200px;
  margin: 0 auto;
  width: 77%;
  .tit {
    font-size: 16px;
    font-weight: bold;
    color: rgba(27, 28, 28, 1);
    i {
      display: inline-block;
      margin-right: 10px;
      width: 19px;
      height: 19px;
    }
  }
  .balanceBox {
    padding-bottom: 30px;
    border-bottom: 1px dashed rgba(214, 209, 209, 1);
    .balanceIcon {
      background: url("../../assets/imgs/memory/userCenter/yb_qb.png") center
        no-repeat;
    }
    .brule {
      height: 24px;
      width: 24px;
      display: inline-block;
      position: relative;
      top: 65px;
      transform: translateY(-50%);
      margin-left: 40px;
      background: url("../../assets/imgs/memory/userCenter/explain_normal.png")
        center no-repeat;
    }
    .brule:hover {
      background: url("../../assets/imgs/memory/userCenter/explain_press.png")
        center no-repeat;
    }
  }
  .balanceMain {
    width: 290px;
    height: 130px;
    display: inline-block;
    background: url("../../assets/imgs/memory/userCenter/integral_bg.png")
      center no-repeat;
    border-radius: 10px;
    margin-left: 100px;
    margin-top: 30px;
    color: white;
    position: relative;
    h5 {
      margin-left: 28px;
      font-size: 16px;
      font-weight: bold;
      position: relative;
      top: 18px;
    }
    p {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      font-size: 30px;
      width: 100%;
      span {
        font-size: 18px;
      }
    }
  }
  // .brule {
  //   padding: 30px 0;
  //   border-bottom: 1px dashed rgba(214, 209, 209, 1);
  //   .bruleIcon {
  //     background: url("../../assets/imgs/memory/userCenter/yb_gz.png") center
  //       no-repeat;
  //   }
  //   h5 {
  //     margin-bottom: 30px;
  //   }
  // }
  .strategy {
    padding: 30px 0;
    .strategyIcon {
      background: url("../../assets/imgs/memory/userCenter/yb_gl.png") center
        no-repeat;
    }
    ul::after {
      content: "";
      display: block;
      clear: both;
    }
    ul {
      margin-left: 100px;
      // margin-top: 30px;
      li {
        float: left;
        width: 290px;
        height: 130px;
        background: url("../../assets/imgs/memory/userCenter/get_points_bg.png")
          center no-repeat;
        border-radius: 10px;
        margin-top: 30px;
        margin-right: 40px;
        text-align: center;
        p {
          color: #4361dd;
          font-size: 20px;
          margin-top: 40px;
          padding: 0 30px;
          span {
            display: block;
            font-size: 14px;
          }
        }
        i {
          color: #67c23a;
          font-size: 18px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>